import React from 'react';
import {
  CheckGroup,
  CustomCheck,
  Input,
} from './CheckInput.styles';

export type CheckInputProps = {
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  type: 'checkbox' | 'radio';
  name: string;
  id?: string;
  checked?:boolean;
  disabled?: boolean;
  autoComplete?: string,
  tabIndex?: number,
  success?: boolean;
  error?: boolean | string;
  ariaDescribedBy?: string;
  value: string;
  className?: string;
};

const CheckInput = ({
  onChange,
  type,
  name,
  id = name,
  checked,
  disabled,
  autoComplete,
  tabIndex,
  error,
  ariaDescribedBy,
  value,
  className,
  ...props
}: CheckInputProps): React.ReactElement => {
  const inputType = `${type === 'checkbox' ? 'checkBox' : ''}`;
  const inputClassName = `${!disabled && !!error ? 'error' : ''} ${inputType}`;
  return (
    <CheckGroup className={className}>
      <Input
        onChange={onChange}
        type={type}
        name={name}
        checked={checked}
        disabled={disabled}
        tabIndex={tabIndex}
        id={id}
        value={value}
        className={inputClassName}
        autoComplete={autoComplete}
        aria-describedby={ariaDescribedBy}
        aria-invalid={!!error}
        {...props}
      />
      <CustomCheck className={inputType} />
    </CheckGroup>
  );
};

export default CheckInput;
